import api from "../api";

export const login = async (email: string, password: string) => {
  try {
    const response = await api.post("/auth/login", { email, password });
    return response.data;
  } catch (error) {
    console.error("Failed to login:", error);
    throw error;
  }
};
export const editUser = async (id: any, data: any) => {
  const response = await api.put(`/api/users`, data, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};
export const addAboutUs = async (payload: any) => {
  try {
    const response = await api.post("/aboutus", payload);
    return response.data;
  } catch (error) {
    console.error("Failed to add About Us content:", error);
    throw error;
  }
};

export const deleteAboutUs = async (id: string) => {
  try {
    const response = await api.delete(`/aboutus/${id}`);
    return response.data;
  } catch (error) {
    console.error("Failed to delete About Us content:", error);
    throw error;
  }
};

export const deleteService = async (id: any) => {
  try {
    const response = await api.delete(`/service/${id}`);
    return response.data;
  } catch (error) {
    console.error("Failed to delete Service content:", error);
    throw error;
  }
};
export const addService = async (formData: FormData) => {
  try {
    const { data } = await api.post("/service", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  } catch (error) {
    console.error("Failed to add Service content:", error);
    throw error;
  }
};

export const addBanner = async (formData: FormData) => {
  try {
    const { data } = await api.post("/banner", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  } catch (error) {
    console.error("Failed to add Banner content:", error);
    throw error;
  }
};
export const deleteBanner = async (id: any) => {
  try {
    const response = await api.delete(`/banner/${id}`);
    return response.data;
  } catch (error) {
    console.error("Failed to delete Banner content:", error);
    throw error;
  }
};

export const editBanner = async (formData: FormData) => {
  try {
    const { data } = await api.put("/banner", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  } catch (error) {
    console.error("Failed to edit Banner content:", error);
    throw error;
  }
};

export const addUser = async (data: any) => {
  const response = await api.post(`users`, data);
  return response.data;
};

export const getAllUsers = async () => {
  const response = await api.get(`users`);
  return response.data;
};

export const deleteUser = async (id: any) => {
  const response = await api.delete(`users/${id}`);
  return response.data;
};

export const editService = async (formData: FormData) => {
  try {
    const { data } = await api.put("/service", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  } catch (error) {
    console.error("Failed to edit Service content:", error);
    throw error;
  }
};

export const addCrew = async (formData: FormData) => {
  console.log("hihihi");
  try {
    const { data } = await api.post("/crew", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  } catch (error) {
    console.error("Failed to add Crew content:", error);
    throw error;
  }
};

export const editCrew = async (formData: FormData) => {
  console.log("hihihi");
  try {
    const { data } = await api.put("/crew", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  } catch (error) {
    console.error("Failed to add Crew content:", error);
    throw error;
  }
};

export const deleteMissionandvision = async (id: any) => {
  try {
    const response = await api.delete(`/missionvision/${id}`);
    return response.data;
  } catch (error) {
    console.error("Failed to add About Us content:", error);
    throw error;
  }
};

export const addMissionandvision = async (payload: any) => {
  try {
    const response = await api.post("/missionvision", payload);
    return response.data;
  } catch (error) {
    console.error("Failed to add About Us content:", error);
    throw error;
  }
};

export const deleteCrew = async (id: any) => {
  try {
    const response = await api.delete(`/crew/${id}`);
    return response.data;
  } catch (error) {
    console.error("Failed to delete Crew content:", error);
    throw error;
  }
};
